module.exports = __webpack_public_path__ + "static/media/linkedin.94393125.png";